<template>
  <transition name="modal">
    <div class="modal-mask">
      <div v-loading="loading" class="modal-wrapper">
        <div class="row d-flex justify-content-center mk-businessdocumentmodal">
          <div class="col-md-6">

            <div class="card shadow">
              <div class="row px-3">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center">
                    <h2 class="my-2">Document Upload</h2>
                    <span class="has-interaction" @click="$emit('close')">
                      <i class="fa-lg fas fa-times"></i>
                    </span>
                  </div>
                  <div class="col-12">
                    <hr />
                  </div>
                </div>
              </div>

              <div class="row p-3 mb-3">
                <div class="col-3">
                  <label for="">Category</label>
                </div>
                <div class="col-9">
                  <div class="input-group">
                    <el-select
                      class="w-100"
                      v-model="collection_name"
                      filterable
                      placeholder="Select"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="row px-3">
                <div class="col-3">
                  <label for="">File</label>
                </div>
                <div class="col-9">
                  <div class="input-group">
                    <input
                      style="height:40px"
                      class="p-0 can-interact"
                      type="file"
                      @change="onFileChange"
                      accept="*"
                    />
                  </div>
                </div>
              </div>


              <div class="row p-3">
                <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-primary" @click="onSubmit">Upload</button>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>




<script>
import Form from "form-backend-validation";
import MediaCollections from "../../../../constants/MediaCollections"

export default {
  props: {
    business: {
      type: Object
    }
  },
  computed: {
    options() {
      return Object.keys(MediaCollections).map(key => {
        return MediaCollections[key];
      });
    }
  },
  data() {
    return {
      //
      document: {},
      loading: false,
      collection_name: "",
      media_collections: MediaCollections,
      form: new Form()
    };
  },
  methods: {
    onSubmit() {
      //
      let formData = new FormData();
      formData.append(`media`, this.document);
      formData.append("collection_name", this.collection_name);
      this.loading = true;
      axios
        .post(`/api/v1/businesses/${this.business.id}/media`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: progressEvent => {
            console.log(
              "Upload Progress:" +
                Math.round((progressEvent.loaded / progressEvent.total) * 100) +
                "%"
            );
          }
        })
        .then(res => {
          this.loading = false;

          this.$message({
            type: "success",
            message: "Your document was stored - you will be notified if there is an issue"
          });
          this.$emit("onAdd", res.data);
          this.$emit("close");
        })
        .catch(errors => {
          this.loading = false;
          var errorText = "";
          _.forEach(errors.response.data.errors, function(value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
          this.form.errors.record(errors.response.data.errors);
        });
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.document = files[0];
    }
  }
};
</script>



<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 1950;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
